module.exports = __webpack_public_path__ + "static/media/stanley.e43603e9.jpeg";